<template>
  <div id="essentials" class="destination-essentials push-v--desktop--small push-v--tablet--small push-v--mobile--small">
    <section class="container destination-essentials--wrapper">
      <h1 class="destination-essentials--title">{{ title }}</h1>
      <div class="destination-essentials--main-content">
        <div v-for="(essential, index) in essentialsList" :key="index" class="destination-essentials--list-item">
          <div class="destination-essentials--list-intro">
            <div class="destination-essentials--list-title">{{ essential.title }}</div>
            <div class="destination-essentials--list-description">{{ essential.description }}</div>
          </div>
          <destination-essentials-carousel :essential="essential" :index="index" />
        </div>
      </div>
    </section>
  </div>
</template>
<script>

export default {
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    essentialsList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  data() {
    return {

    };
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_destination-essentials.scss';
</style>
